<svg
  class="u-width-100 u-height-100"
  width="904"
  height="136"
  viewBox="0 0 904 136"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="904" height="136" fill="url(#paint0_linear)" />
  <mask
    id="mask0"
    mask-type="alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="904"
    height="136"
  >
    <rect width="904" height="136" fill="white" />
  </mask>
  <g mask="url(#mask0)">
    <path
      opacity="0.1"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M667.095 33.5739C671.148 -9.59055 888.642 -92.9024 929.018 -52.0179C969.395 -11.1335 959.175 74.8623 874.56 94.5108C789.945 114.159 663.041 76.7383 667.095 33.5739Z"
      fill="#DDE3E9"
    />
    <path
      opacity="0.1"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M713.314 191.678C708.789 140.869 465.985 42.8016 420.91 90.9271C375.834 139.053 419.169 229.371 513.631 252.5C608.093 275.628 717.84 242.487 713.314 191.678Z"
      fill="#F2F2F2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M547.38 19.5034C539.676 19.5034 533.43 25.7491 533.43 33.4534V44.6729C533.43 51.661 538.568 57.449 545.273 58.4648C545.276 58.5218 545.279 58.5791 545.283 58.6366H563.263C566.32 55.6914 562.865 35.7147 560.71 29.0941C560.327 27.9184 559.96 27.1576 559.599 26.7173C557.223 22.4162 552.642 19.5034 547.38 19.5034Z"
      fill="#191847"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M547.65 48.9924C551.665 51.3782 555.61 52.5309 557.461 52.0603C562.105 50.8804 562.532 34.1336 558.939 27.5315C555.346 20.9294 536.876 18.0518 535.945 31.1327C535.622 35.6726 537.556 39.7242 540.413 43.0303L535.29 66.5691H550.17L547.65 48.9924Z"
      fill="#B28B67"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M533.976 31.209C534.408 30.7878 534.826 30.3803 535.241 30.0156L535.221 29.5405C535.221 29.5405 539.891 20.1147 547.071 20.1147C554.244 20.1147 556.513 23.4024 558.441 26.1971L558.446 26.2046C557.438 29.6166 554.398 30.9971 550.96 32.5583C549.48 33.2304 547.926 33.936 546.429 34.8515C545.842 34.3817 545.095 34.1002 544.28 34.1002C542.397 34.1002 540.87 35.6053 540.87 37.462C540.87 39.3187 542.397 40.8239 544.28 40.8239C544.332 40.8239 544.384 40.8227 544.435 40.8204C545.121 48.0808 544.846 56.3719 542.803 58.34H524.823C524.307 49.499 526.626 46.9769 528.997 44.3998C531.227 41.9749 533.503 39.5012 533.503 31.6689C533.663 31.5148 533.82 31.361 533.976 31.2091L533.976 31.209Z"
      fill="#191847"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M534.12 224.087C560.486 224.087 581.86 203.973 581.86 179.161C581.86 154.349 560.486 134.235 534.12 134.235C507.754 134.235 486.38 154.349 486.38 179.161C486.38 203.973 507.754 224.087 534.12 224.087Z"
      fill="#C5CFD6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M608.341 176.765C610.647 184.728 616.392 199.822 624.336 217.156L631.884 214.984C625.28 175.098 619.784 148.691 616.636 140.654C614.556 135.344 598.819 135.966 600.629 146.651C601.389 151.131 604.392 163.13 608.341 176.765ZM577.314 148.514C565.003 151.028 539.479 159.917 532.191 162.757C527.61 164.542 530.563 170.596 534.471 170.067C535.133 169.977 537.474 169.719 540.967 169.333C552.188 168.096 575.295 165.547 592.821 163.061C602.049 161.751 597.085 144.71 587.503 146.513C584.28 147.12 580.851 147.791 577.314 148.514Z"
      fill="#B28B67"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M617.119 136.153C615.86 132.104 558.649 117.731 558.649 117.731H553.96V122.038L593.384 141.824C593.332 142.462 593.364 143.137 593.491 143.849C593.206 158.517 599.574 169.474 605.878 180.323C610.001 187.418 614.096 194.466 616.287 202.475L630.771 200.344C630.349 199.28 629.682 194.484 628.77 187.925C626.47 171.389 622.612 143.653 617.2 136.315C617.181 136.289 617.162 136.264 617.142 136.239C617.135 136.21 617.127 136.181 617.119 136.153Z"
      fill="#2F3676"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M557.235 153.575C553.628 152.863 550.306 152.227 547.464 151.736C529.104 148.561 523.75 138.872 526.915 117.731H560.744C566.27 119.296 594.988 131.169 609.888 137.484C619.75 141.664 616.641 156.731 611.056 160.652C611.026 160.893 610.925 161.056 610.747 161.129C589.573 169.781 571.517 169.136 559.922 168.721C555.066 168.547 551.344 168.414 549 169.022L545.328 157.601L557.235 153.575Z"
      fill="#2F3676"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M613.368 90.741L590.902 100.468L598.076 109.528L614.901 96.8098C623.305 95.288 627.202 93.9806 626.594 92.8877C626.08 91.9662 625.125 91.9142 624.245 91.8664C623.559 91.8291 622.919 91.7943 622.57 91.3529C621.771 90.3448 623.741 87.2306 625.739 84.3541C627.737 81.4776 625.864 81.5815 624.768 81.9255C621.103 83.9363 617.303 86.8748 613.368 90.741ZM512.782 105.632L500.078 103.147C491.461 125.536 486.324 137.805 484.667 139.954C483.451 141.53 475.956 145.589 470.883 147.757C468.846 148.627 469.284 150.324 469.881 150.867C473.648 154.29 477.15 153.09 480.963 151.784C482.067 151.406 483.196 151.019 484.366 150.732C487.393 149.991 488.315 151.526 489.185 152.977C489.956 154.261 490.687 155.479 492.806 154.993C492.709 154.583 492.591 154.124 492.463 153.628C491.637 150.425 490.42 145.701 492.226 142.957C493.153 141.548 500.005 129.107 512.782 105.632Z"
      fill="#B28B67"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M547.313 56.2841L552.675 55.3775C564.352 66.545 569.117 93.3745 576.899 96.9258C584.257 100.283 594.687 97.0343 607.084 92.6471L610.881 101.01C599.617 113.025 575.619 123.175 565.892 117.38C550.34 108.116 546.75 75.0258 547.313 56.2841Z"
      fill="#8991DC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M523.942 122.706C523.942 122.706 556.187 122.706 571.379 122.706C573.547 122.706 573.139 119.621 572.825 118.064C569.209 100.093 555.092 80.7212 555.092 55.1402L541.409 53.0249C530.091 70.97 526.177 93.064 523.942 122.706Z"
      fill="#DDE3E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M540.682 53.0249H540.526C509.835 71.6704 491.287 100.574 484.882 139.735L494.826 141.655C501.412 134.09 509.541 121.709 519.211 104.512C516.244 114.871 514.078 125.496 513.402 135.542H556.103C564.37 114.947 545.944 53.0249 545.944 53.0249H542.996H540.682Z"
      fill="#8991DC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M763.334 48.0277C759.334 50.4672 755.405 51.6458 753.56 51.1647C748.934 49.9581 748.509 32.8344 752.088 26.0837C755.667 19.333 774.067 16.3906 774.994 29.7659C775.316 34.408 773.39 38.5509 770.544 41.9313L775.647 66H760.824L763.334 48.0277Z"
      fill="#B28B67"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M754.913 18.9192C751.557 19.1538 748.806 19.3461 747.713 18.6418C746.908 23.7441 749.503 27.8582 758.626 27.0628C760.637 28.2015 762.069 30.3351 763.792 33.1337C764.212 32.9668 764.669 32.8751 765.147 32.8751C767.194 32.8751 768.853 34.554 768.853 36.6251C768.853 37.6765 768.425 38.6268 767.737 39.3077C768.594 40.5325 769.555 41.8119 770.656 43.1321C774.331 40.9013 777.163 34.8518 774.917 28.5781C774.946 28.5529 774.974 28.5269 775 28.5001C774.646 17.54 763.015 18.3529 754.913 18.9192Z"
      fill="#191847"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M725.506 159.025C725.506 159.025 753.868 154.41 763.5 152.714C781.804 149.49 787.142 139.652 783.986 118.187L750.261 118.187C743.566 120.118 694.316 142.071 694.316 142.071C688.409 145 689.509 153.636 690.589 156.481C690.655 156.655 720.465 207.613 720.465 207.613L748.054 190.059L725.454 161.094C725.454 161.094 724.559 159.293 725.506 159.025Z"
      fill="#5C63AB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M703.565 123.731L723.252 109.201L727.604 120.013L708.109 128.139C702.595 134.648 699.512 137.362 698.859 136.28C698.309 135.367 698.739 134.513 699.136 133.726C699.444 133.113 699.732 132.541 699.52 132.015C699.036 130.811 695.332 130.938 691.823 131.209C688.313 131.481 689.336 129.911 690.182 129.136C693.764 126.981 698.226 125.179 703.565 123.731ZM806.809 149.333C805.001 145.646 798.841 109.702 798.841 109.702L785.944 109.753C785.944 109.753 797.889 148.511 798.841 150.883C800.078 153.963 797.977 158.439 796.553 161.474C796.332 161.944 796.128 162.379 795.955 162.769C797.932 163.658 798.881 162.583 799.882 161.45C801.013 160.171 802.209 158.817 805.026 160.134C806.114 160.643 807.143 161.244 808.149 161.832C811.624 163.862 814.816 165.727 819.158 163.034C819.847 162.607 820.601 160.999 818.779 159.743C814.237 156.614 807.693 151.136 806.809 149.333Z"
      fill="#B28B67"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M762.188 55.3076L756.851 54.3875C737.05 71.58 728.917 104.609 704.645 122.105L710.487 129.384C752.594 124.144 763.031 83.8565 762.188 55.3076Z"
      fill="#191847"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M785.453 122.717C785.453 122.717 753.355 122.717 738.231 122.717C736.074 122.717 736.48 119.585 736.792 118.005C740.392 99.767 754.445 80.1077 754.445 54.1468L768.066 52C779.332 70.2116 783.228 92.6338 785.453 122.717Z"
      fill="#DDE3E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M790.763 135.743C792.885 140.866 794.966 145.336 796.927 148.77H807.055C808.144 113.361 794.806 86.1153 783.644 69.687C786.122 69.509 788.359 68.4666 789.774 65.902C794.752 56.8732 792.954 51.9021 787.634 50.2681C784.708 49.3696 781.956 49.9829 778.663 50.7171C775.967 51.3178 772.909 51.9995 769.095 51.9999C769.094 51.9999 769.093 51.9999 769.092 51.9999C768.722 51.9999 768.386 52.0248 768.08 52.0724L763.561 52.3316C763.561 52.3316 745.209 114.842 753.438 135.743H790.763Z"
      fill="#191847"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M790.763 135.743C787.978 129.021 785.123 121.176 782.375 113.073C781.352 121.996 779.649 130.958 776.813 135.743H790.763Z"
      fill="black"
      fill-opacity="0.1"
    />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear"
      x1="452"
      y1="204"
      x2="492.015"
      y2="-61.9801"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#2D3CCF" />
      <stop offset="1" stop-color="#5F81E5" />
    </linearGradient>
  </defs>
</svg>
